Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Grid3915352077",
  {"root":"Grid3915352077--root","item":"Grid3915352077--item","listWrapper":"Grid3915352077--listWrapper","DefaultDividerColor":"color-5","MainDividerColor":"--overidable","dividerColor":"\"color(fallback(--overidable, opacity(color(color-5), 0.2)))\""},
  "",
  1,
  "Grid3915352077"
);

